module.exports = __webpack_public_path__ + "static/media/logo.18d84d40.svg";